/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import { Box, Paper, Skeleton, Stack, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "swiper/css";
import Heading from "../heading";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getTrustedPartners } from '../../redux/slices/common';

const LOGOS = [
    { src: "/img/trusted_partners/partner1.svg", alt: "Jetex" },
    { src: "/img/trusted_partners/partner2.svg", alt: "Emirates" },
    { src: "/img/trusted_partners/partner3.svg", alt: "dnata" },
    { src: "/img/trusted_partners/partner4.svg", alt: "marhaba" },
    { src: "/img/trusted_partners/partner5.svg", alt: "BVLGARI" },
    { src: "/img/trusted_partners/partner6.svg", alt: "Air Arabia" },
    { src: "/img/trusted_partners/partner7.svg", alt: "flydubai" },
    // add more…
];

export default function TrustedPartners() {
    const dispatch = useDispatch();
    const { trustesPartnersRes } = useSelector((state) => state.common);
    const [images, setImages] = useState([]);
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        dispatch(getTrustedPartners());
        setLoader(true);
    }, [dispatch])

    useEffect(() => {
        if (trustesPartnersRes) {
            setLoader(false);
            if (trustesPartnersRes?.status === 1) {
                setImages(trustesPartnersRes?.ourPartners ?? []);
            } else {
                setImages([]);
            }
        }
    }, [trustesPartnersRes])

    return (
        <Box sx={{ py: { xs: 6, md: 6 } }}>
            {/* Heading */}
            <Heading title="Trusted Partners" />

            {/* Carousel */}
            {
                loader ?
                    < Stack
                        direction="row"
                        spacing={{ xs: 2, md: 4 }}
                        justifyContent="center"
                        flexWrap="wrap"
                    >
                        {Array.from({ length: 5 }).map((_, index) => (
                            <Box key={index}>
                                <Skeleton
                                    variant="rounded"
                                    width={140}
                                    height={110}
                                    sx={{ borderRadius: 4 }}
                                />
                            </Box>
                        ))}
                    </Stack> :
                    <Box sx={{ mx: "auto", px: { xs: 2, md: 0 } }}>
                        <Swiper
                            modules={[Autoplay]}
                            autoplay={{ delay: 0, disableOnInteraction: false, pauseOnMouseEnter: true }}
                            speed={3500}
                            loop
                            slidesPerView="auto"
                            spaceBetween={22}
                            style={{ padding: "4px 2px" }}
                        >
                            {images?.map((l, i) => (
                                <SwiperSlide key={i} style={{ width: 260 }}>
                                    <LogoCard {...l} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </Box>
            }

        </Box >
    );
}

/* single logo tile */
function LogoCard({ image, name }) {
    return (
        <Paper
            elevation={0}
            sx={{
                height: 140,
                borderRadius: 3,
                bgcolor: "#f7f7f7",
                border: "1px solid #f0f0f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "transform .2s ease, box-shadow .2s ease",
                "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 10px 24px rgba(0,0,0,.06)",
                },
            }}
        >
            <Box sx={{ position: "relative", width: 160, height: 64, filter: "grayscale(100%)", opacity: 0.65 }}>
                <Image src={`${process.env.IMAGE_BASE_URL}/${image}`} alt={name} fill sizes="160px" style={{ objectFit: "contain" }} />
            </Box>
        </Paper>
    );
}
